import { render, staticRenderFns } from "./summary-card.vue?vue&type=template&id=77bb3458&scoped=true&"
import script from "./summary-card.vue?vue&type=script&lang=js&"
export * from "./summary-card.vue?vue&type=script&lang=js&"
import style0 from "./summary-card.vue?vue&type=style&index=0&id=77bb3458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bb3458",
  null
  
)

export default component.exports